import { NgModule } from '@angular/core';

import { MasterAssociarFundosActions } from './master-associar-fundos.actions';
import { SalvarAssociacaoAction } from './master-salvar-associacao-associar-fundos.action';

@NgModule({
  providers: [
      SalvarAssociacaoAction,
    MasterAssociarFundosActions
  ]
})
export class MasterAssociarFundosActionsModule {}
